import { render, staticRenderFns } from "./Error-2.vue?vue&type=template&id=74834b4a&"
import script from "./Error-2.vue?vue&type=script&lang=js&"
export * from "./Error-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports